import React, { useState, useEffect } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../services/api';

function Login() {
    const { isAuthenticated, loading } = useAuth();
    const [searchParams] = useSearchParams();
    const [authConfigured, setAuthConfigured] = useState(null);
    const [checking, setChecking] = useState(true);

    const error = searchParams.get('error');

    useEffect(() => {
        authAPI.status()
            .then(res => setAuthConfigured(res.data.configured))
            .catch(() => setAuthConfigured(false))
            .finally(() => setChecking(false));
    }, []);

    if (loading || checking) {
        return (
            <div className="login-page">
                <div className="login-card">
                    <div className="loading">
                        <div className="spinner"></div>
                        <span>Carregando...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }

    const backendUrl = process.env.REACT_APP_API_URL
        ? process.env.REACT_APP_API_URL.replace('/api', '')
        : 'http://localhost:3167';

    const handleGoogleLogin = () => {
        window.location.href = `${backendUrl}/api/auth/google`;
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-logo">
                    <span className="login-logo-icon">&#9729;</span>
                    <h1>Cloudflare DNS Manager</h1>
                    <p>Gerencie e valide seus registros DNS</p>
                </div>

                {error && (
                    <div className="login-error">
                        {error === 'auth_failed'
                            ? 'Falha na autenticacao. Email nao autorizado.'
                            : 'Erro ao fazer login. Tente novamente.'}
                    </div>
                )}

                {authConfigured === false ? (
                    <div className="login-warning">
                        Google OAuth nao configurado. Configure GOOGLE_CLIENT_ID e
                        GOOGLE_CLIENT_SECRET no servidor.
                    </div>
                ) : (
                    <button className="login-google-btn" onClick={handleGoogleLogin}>
                        <svg className="google-icon" viewBox="0 0 24 24" width="20" height="20">
                            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                        </svg>
                        Entrar com Google
                    </button>
                )}

                <div className="login-footer">
                    Acesso restrito a usuarios autorizados
                </div>
            </div>
        </div>
    );
}

export default Login;
